import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

// Icons
import { FaGlobeAsia, FaPlaneDeparture, FaHeadset, FaCheckCircle, FaAward, FaSmile } from "react-icons/fa";

// Components
import Navr from "../Navbar/Navr";
import Footer from "../Components2/Footer";

// Images
import heroImg from '../Ecomphotos/bass.jpg'; // Using this as Hero BG
import aboutSideImg from '../Ecomphotos/abb.jpg'; // Or use a different one for the side

// import "./AboutStyle.css"; // Custom CSS

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="about-page">
      <Navr />

      {/* --- Section 1: Hero Banner --- */}
      <div className="about-hero d-flex align-items-center justify-content-center" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="hero-overlay"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h5 className="text-warning text-uppercase ls-2 mb-3">Who We Are</h5>
            <h3 className="display-4 fw-bold text-white mb-4">Crafting Memories, Not Just Trips</h3>
            <p className="text-white lead mx-auto opacity-75" style={{ maxWidth: "700px" }}>
              Your trusted partner for exploring the world's most beautiful destinations.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Main Story (About Us) --- */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="align-items-center my-5">
            <Col lg={6} className="mb-5 mb-lg-0" data-aos="fade-right">
              <h6 className="text-danger fw-bold text-uppercase">About Jawali Holidays</h6>
              <h2 className="display-6 fw-bold mb-4 text-dark">
                We Make Your Dream <br /> <span className="text-primary-custom">Vacation a Reality</span>
              </h2>
              <p className="text-muted lead-sm text-justify">
                At Jawali Holidays, we believe travel is more than just a journey — it’s about creating memories that last forever. 
                From breathtaking mountain ranges to serene beaches and vibrant cities, we curate experiences that reflect your passion for adventure.
              </p>
              
              <ul className="list-unstyled mt-4">
                <li className="d-flex align-items-center mb-3">
                  <FaCheckCircle className="text-success me-3 fs-5" />
                  <span><strong>Personalized Experiences:</strong> Trips designed to match your needs.</span>
                </li>
                <li className="d-flex align-items-center mb-3">
                  <FaCheckCircle className="text-success me-3 fs-5" />
                  <span><strong>Affordable Packages:</strong> Best deals without compromising comfort.</span>
                </li>
                <li className="d-flex align-items-center mb-3">
                  <FaCheckCircle className="text-success me-3 fs-5" />
                  <span><strong>Expert Guidance:</strong> Professionals with years of experience.</span>
                </li>
              </ul>

              <Link to="/contact" className="btn btn-danger px-4 py-2 mt-3 rounded-pill shadow-sm">
                Contact Us Today
              </Link>
            </Col>

            <Col lg={6} data-aos="fade-left">
              <div className="image-stack-container">
                <img src={aboutSideImg} alt="Travel" className="img-fluid rounded-4 shadow-lg main-img" />
                <div className="experience-badge">
                   <span className="fw-bold h2 m-0">8+</span>
                   <span className="small">Years of<br/>Excellence</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 3: Stats Counter (Trust Builders) --- */}
      <section className="py-5 bg-danger text-white">
        <Container>
           <Row className="text-center">
              <Col md={4} className="mb-4 mb-md-0" data-aos="zoom-in">
                 <FaSmile className="display-4 mb-3 opacity-75" />
                 <h2 className="fw-bold">500+</h2>
                 <p className="mb-0 text-white-50">Happy Travelers</p>
              </Col>
              <Col md={4} className="mb-4 mb-md-0" data-aos="zoom-in" data-aos-delay="200">
                 <FaGlobeAsia className="display-4 mb-3 opacity-75" />
                 <h2 className="fw-bold">50+</h2>
                 <p className="mb-0 text-white-50">Destinations</p>
              </Col>
              <Col md={4} data-aos="zoom-in" data-aos-delay="400">
                 <FaAward className="display-4 mb-3 opacity-75" />
                 <h2 className="fw-bold">100%</h2>
                 <p className="mb-0 text-white-50">Satisfaction Guaranteed</p>
              </Col>
           </Row>
        </Container>
      </section>

      {/* --- Section 4: What We Offer (Services) --- */}
      <section className="py-5 bg-light">
        <Container>
          <div className="text-center mb-5" data-aos="fade-up">
            <h6 className="text-danger fw-bold text-uppercase">Our Services</h6>
            <h2 className="fw-bold">Why Choose Us?</h2>
            <div className="separator mx-auto"></div>
          </div>

          <Row>
            {/* Card 1 */}
            <Col md={4} className="mb-4" data-aos="flip-left">
              <div className="service-card p-4 bg-white h-100 text-center">
                <div className="icon-circle bg-light-danger mb-4">
                  <FaGlobeAsia className="text-danger fs-3" />
                </div>
                <h5 className="fw-bold">Customized Tours</h5>
                <p className="text-muted small">
                  We don't believe in one-size-fits-all. Get packages that match your style, budget & dreams perfectly.
                </p>
              </div>
            </Col>
            
            {/* Card 2 */}
            <Col md={4} className="mb-4" data-aos="flip-up">
              <div className="service-card p-4 bg-white h-100 text-center">
                <div className="icon-circle bg-light-warning mb-4">
                  <FaPlaneDeparture className="text-warning fs-3" />
                </div>
                <h5 className="fw-bold">Holiday Packages</h5>
                <p className="text-muted small">
                  From family trips to honeymoons and luxury getaways, we cover destinations worldwide.
                </p>
              </div>
            </Col>

            {/* Card 3 */}
            <Col md={4} className="mb-4" data-aos="flip-right">
              <div className="service-card p-4 bg-white h-100 text-center">
                <div className="icon-circle bg-light-info mb-4">
                  <FaHeadset className="text-info fs-3" />
                </div>
                <h5 className="fw-bold">24/7 Support</h5>
                <p className="text-muted small">
                  Travel worry-free! We handle hotels, flights, and provide round-the-clock assistance.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 5: Vision & Promise --- */}
      <section className="py-5 bg-white">
        <Container>
           <Row className="g-4">
             <Col md={6} data-aos="fade-right">
                <div className="vision-box p-5 rounded-4 bg-dark text-white h-100">
                   <h3 className="fw-bold mb-3">Our Vision</h3>
                   <p className="opacity-75 lead-sm">
                     To be recognized as a trusted travel partner that creates journeys filled with joy, adventure, and lifelong memories. We aim to inspire the world to explore more.
                   </p>
                </div>
             </Col>
             <Col md={6} data-aos="fade-left">
                <div className="promise-box p-5 rounded-4 bg-light border h-100">
                   <h3 className="fw-bold text-danger mb-3">Our Promise</h3>
                   <p className="text-muted lead-sm">
                     With <b>Jawali Holidays</b>, you don’t just book a trip – you begin a journey towards beautiful experiences. We promise transparency, quality, and care in every step.
                   </p>
                </div>
             </Col>
           </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
}